(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.root = window.Shopify?.routes?.root || '/';

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog || event.target.closest('[data-cart-close]')) this.close();
        const change = event.target.closest('a[data-cart-change]');
        if (change) {
          event.preventDefault();
          this.change(change.closest('[data-line]').dataset.line, change.dataset.quantity);
        }
      });

      // The header cart link opens the drawer; without JS it is a plain link to /cart
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-cart-trigger]');
        if (!trigger || event.metaKey || event.ctrlKey) return;
        event.preventDefault();
        this.open(trigger);
      });

      document.addEventListener('submit', (event) => {
        const form = event.target.closest('form[data-cart-add]');
        if (!form) return;
        event.preventDefault();
        this.add(form, event.submitter);
      });
    }

    open(trigger) {
      this.trigger = trigger || document.activeElement;
      if (!this.dialog.open) this.dialog.showModal();
    }

    close() {
      this.dialog.close();
      this.trigger?.focus?.();
    }

    async add(form, submitter) {
      const button = submitter || form.querySelector('[type="submit"]');
      const note = form.querySelector('[data-cart-note]');
      if (note) note.textContent = '';
      if (button) button.disabled = true;
      const body = new FormData(form);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', location.pathname);
      try {
        // The Cart API accepts a second unit of a stock-1 original (checkout rejects it later),
        // so forms for originals carry data-original and are checked against the cart first
        if (form.hasAttribute('data-original') && (await this.inCart(body.get('id')))) {
          if (note) note.textContent = this.dataset.already;
          return;
        }
        const response = await fetch(`${this.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body,
        });
        const data = await response.json();
        if (!response.ok) {
          // An Original already in the cart: stock is 1, so a second add is refused (DECISIONS.md #3)
          const inCart = await this.inCart(body.get('id'));
          if (note) note.textContent = inCart ? this.dataset.already : data.description || this.dataset.error;
          return;
        }
        this.swap(data.sections?.['cart-drawer']);
        this.open(button);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'add', item: data } }));
      } catch {
        if (note) note.textContent = this.dataset.error;
      } finally {
        if (button) button.disabled = false;
      }
    }

    async inCart(variantId) {
      try {
        const cart = await (await fetch(`${this.root}cart.js`)).json();
        return cart.items.some((item) => String(item.variant_id) === String(variantId));
      } catch {
        return false;
      }
    }

    async change(line, quantity) {
      this.classList.add('is-busy');
      try {
        const response = await fetch(`${this.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: 'cart-drawer' }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description);
        this.swap(data.sections?.['cart-drawer'], line);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'change', cart: data } }));
      } catch {
        this.querySelector('[data-cart-status]').textContent = this.dataset.error;
      } finally {
        this.classList.remove('is-busy');
      }
    }

    // Replace the drawer contents (the dialog stays open) and sync the header count
    swap(html, focusLine) {
      if (!html) return location.reload();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-cart-drawer-inner]');
      this.querySelector('[data-cart-drawer-inner]').replaceWith(inner);

      const head = inner.querySelector('[data-cart-count-value]');
      for (const count of document.querySelectorAll('[data-cart-count]')) count.textContent = head.dataset.cartCountValue;
      for (const link of document.querySelectorAll('[data-cart-trigger]')) {
        link.setAttribute('aria-label', head.dataset.cartCountLabel);
      }

      // Keep keyboard focus inside the drawer after a change
      if (focusLine && this.dialog.open) {
        const line = inner.querySelector(`[data-line="${focusLine}"]`);
        (line?.querySelector('[data-cart-change]') || inner.querySelector('[data-cart-close]')).focus();
      }
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-carousel"] && !Shopify.designMode) return;
  try {
    
  class FeaturedCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.media = [...this.querySelectorAll('[data-slide-media]')];
      this.segments = [...this.querySelectorAll('[data-go]')];
      this.live = this.querySelector('[data-live]');
      this.index = 0;
      if (this.slides.length < 2) return;

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.segments.forEach((segment) => segment.addEventListener('click', () => this.go(Number(segment.dataset.go))));

      // Arrow keys while focus is anywhere in the carousel (not inside a text field)
      this.addEventListener('keydown', (event) => {
        if (event.target.matches('input, textarea, select')) return;
        if (event.key === 'ArrowLeft') this.go(this.index - 1, true);
        if (event.key === 'ArrowRight') this.go(this.index + 1, true);
      });

      // Swipe on the image
      const swipe = this.querySelector('[data-swipe]');
      swipe.addEventListener('pointerdown', (event) => {
        this.swiped = false;
        this.startX = event.clientX;
        this.startY = event.clientY;
      });
      swipe.addEventListener('pointerup', (event) => {
        if (this.startX == null) return;
        const dx = event.clientX - this.startX;
        const dy = event.clientY - this.startY;
        this.startX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          this.swiped = true;
          this.go(this.index + (dx < 0 ? 1 : -1));
        }
      });
      swipe.addEventListener('click', (event) => {
        // A swipe shouldn't also follow the image link
        if (this.swiped) event.preventDefault();
      });
    }

    go(next, fromKey = false) {
      const count = this.slides.length;
      const index = (next + count) % count;
      if (index === this.index) return;
      this.classList.add('is-moved');
      this.slides[this.index].hidden = true;
      this.media[this.index].hidden = true;
      this.segments[this.index].setAttribute('aria-current', 'false');
      this.index = index;
      this.slides[index].hidden = false;
      this.media[index].hidden = false;
      this.segments[index].setAttribute('aria-current', 'true');
      if (fromKey) this.segments[index].focus();
      const title = this.slides[index].querySelector('.carousel__title').textContent.trim();
      this.live.textContent = `${this.slides[index].getAttribute('aria-label')}: ${title}`;
    }
  }
  if (!customElements.get('featured-carousel')) customElements.define('featured-carousel', FeaturedCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class MenuDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.querySelector('[data-open]').addEventListener('click', () => this.dialog.showModal());
      this.dialog.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', () => this.dialog.close()));
      this.dialog.querySelectorAll('a[href]').forEach((el) => el.addEventListener('click', () => this.dialog.close()));
      window.matchMedia('(min-width: 990px)').addEventListener('change', (e) => e.matches && this.dialog.close());
    }
  }
  if (!customElements.get('menu-drawer')) customElements.define('menu-drawer', MenuDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  class CollectionView extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.addEventListener('input', this.onInput);
      this.addEventListener('submit', this.onSubmit);
      this.addEventListener('toggle', this.onToggle, true);
      this.onOutside = (event) => {
        if (!event.target.closest('.facet')) this.closePanels();
      };
      this.onKey = (event) => {
        if (event.key !== 'Escape') return;
        const open = this.querySelector('.facet[open]');
        if (open) {
          open.open = false;
          open.querySelector('summary').focus();
        }
      };
      this.onPop = () => this.render(location.href, { push: false });
      document.addEventListener('click', this.onOutside);
      document.addEventListener('keydown', this.onKey);
      window.addEventListener('popstate', this.onPop);
      this.loadEarlier();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onOutside);
      document.removeEventListener('keydown', this.onKey);
      window.removeEventListener('popstate', this.onPop);
    }

    get sheet() {
      return this.querySelector('.filter-sheet');
    }

    onClick = (event) => {
      const target = event.target;
      if (target.closest('[data-open-sheet]')) {
        this.sheet.showModal();
      } else if (target.closest('[data-close-sheet]') || target === this.sheet) {
        this.sheet.close();
      } else if (target.closest('a[data-load-more]')) {
        event.preventDefault();
        this.loadMore(target.closest('a').href);
      } else if (target.closest('a[data-facet-link]')) {
        event.preventDefault();
        if (this.sheet.open) this.sheet.close();
        this.render(target.closest('a').href);
      }
    };

    onChange = (event) => {
      const form = event.target.form;
      if (form?.hasAttribute('data-live') && event.target.type !== 'number') this.apply(form);
    };

    onInput = (event) => {
      const form = event.target.form;
      if (!form?.hasAttribute('data-live') || event.target.type !== 'number') return;
      clearTimeout(this.typing);
      this.typing = setTimeout(() => this.apply(form), 600);
    };

    onSubmit = (event) => {
      event.preventDefault();
      if (this.sheet.open) this.sheet.close();
      this.apply(event.target);
    };

    // One desktop panel open at a time
    onToggle = (event) => {
      if (event.target.matches?.('.facet[open]')) this.closePanels(event.target);
    };

    closePanels(except) {
      for (const panel of this.querySelectorAll('.facet[open]')) if (panel !== except) panel.open = false;
    }

    apply(form) {
      const params = new URLSearchParams();
      for (const [key, value] of new FormData(form)) {
        if (value === '' || (key === 'sort_by' && value === form.dataset.defaultSort)) continue;
        params.append(key, value);
      }
      const query = params.toString();
      this.render(query ? `${form.action}?${query}` : form.action);
    }

    async fetchSection(url) {
      const request = new URL(url, location.href);
      request.searchParams.set('section_id', this.dataset.sectionId);
      const response = await fetch(request);
      if (!response.ok) throw new Error(response.status);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      return doc.querySelector('collection-view');
    }

    // Swap the bar and results; keep the open panel and focus so several boxes can be ticked in a row
    async render(url, { push = true } = {}) {
      const target = new URL(url, location.href);
      target.searchParams.delete('page');
      const openKey = this.querySelector('.facet[open]')?.dataset.key;
      const focusId = this.contains(document.activeElement) ? document.activeElement.id : null;
      this.classList.add('is-loading');
      try {
        const next = await this.fetchSection(target);
        this.replaceChildren(...next.childNodes);
        if (openKey) {
          const panel = this.querySelector(`.facet[data-key="${CSS.escape(openKey)}"]`);
          if (panel) panel.open = true;
        }
        if (focusId) document.getElementById(focusId)?.focus({ preventScroll: true });
        if (push) history.pushState(null, '', target);
      } catch {
        location.assign(target);
      } finally {
        this.classList.remove('is-loading');
      }
    }

    // Load more (SPEC §4.5): append the next page; nothing already on screen moves
    async loadMore(url) {
      const button = this.querySelector('[data-load-more]');
      button.setAttribute('aria-disabled', 'true');
      try {
        const next = await this.fetchSection(url);
        this.querySelector('.artwork-grid').append(...next.querySelectorAll('.artwork-grid__item'));
        const pagination = next.querySelector('[data-pagination]');
        if (pagination) this.querySelector('[data-pagination]').replaceWith(pagination);
        else this.querySelector('[data-pagination]').remove();
        history.replaceState(null, '', url);
      } catch {
        location.assign(url);
      }
    }

    // Arriving on ?page=n (a reload after Load more): bring back pages 1..n-1 above, holding the view still
    async loadEarlier() {
      const link = this.querySelector('[data-load-earlier]');
      if (!link) return;
      const url = new URL(location.href);
      const page = parseInt(url.searchParams.get('page'), 10) || 1;
      const grid = this.querySelector('.artwork-grid');
      const anchor = grid.firstElementChild;
      const before = anchor.getBoundingClientRect().top;
      try {
        const pages = [];
        for (let n = 1; n < page; n++) {
          url.searchParams.set('page', n);
          pages.push(this.fetchSection(url));
        }
        const items = (await Promise.all(pages)).flatMap((doc) => [...doc.querySelectorAll('.artwork-grid__item')]);
        grid.prepend(...items);
        link.parentElement.remove();
        requestAnimationFrame(() => window.scrollBy(0, anchor.getBoundingClientRect().top - before));
      } catch {
        // The "Show earlier work" link stays as the fallback
      }
    }
  }
  if (!customElements.get('collection-view')) customElements.define('collection-view', CollectionView);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"]) return;
  try {
    
  class ContactPage extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form.contact__form');
      if (!this.form || !this.querySelector('[data-piece-slot]')) return;
      this.form.addEventListener('submit', this.onSubmit);
      const handle = new URL(location.href).searchParams.get('piece');
      if (handle && /^[a-z0-9-]+$/i.test(handle)) this.loadPiece(handle);
    }

    async loadPiece(handle) {
      try {
        const response = await fetch(`/products/${encodeURIComponent(handle)}?section_id=contact-piece-card`);
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const card = doc.querySelector('.contact-piece');
        if (!card) return;
        this.querySelector('[data-piece-slot]').replaceChildren(card);
        card.querySelector('[data-piece-remove]').addEventListener('click', () => this.removePiece());

        const { pieceTitle, pieceUrl } = card.dataset;
        const input = this.querySelector('[data-piece-input]');
        input.value = `${pieceTitle} (${pieceUrl})`;
        input.disabled = false;
        this.setHeading(this.dataset.pieceTitle, this.dataset.pieceLede);

        const message = this.querySelector('[data-contact-message]');
        if (!message.value.trim()) {
          this.prefill = this.dataset.prefill.replace('__TITLE__', pieceTitle);
          message.value = this.prefill;
        }
      } catch {
        // Without the card it's still a working contact form
      }
    }

    removePiece() {
      this.querySelector('[data-piece-slot]').replaceChildren();
      const input = this.querySelector('[data-piece-input]');
      input.value = '';
      input.disabled = true;
      this.setHeading(this.dataset.defaultTitle, this.dataset.defaultLede);
      const message = this.querySelector('[data-contact-message]');
      if (this.prefill && message.value === this.prefill) message.value = '';
      const url = new URL(location.href);
      url.searchParams.delete('piece');
      history.replaceState(null, '', url);
      message.focus();
    }

    setHeading(title, lede) {
      if (title) this.querySelector('[data-contact-title]').textContent = title;
      const ledeEl = this.querySelector('[data-contact-lede]');
      ledeEl.textContent = lede;
      ledeEl.hidden = !lede;
    }

    // "Also send me letters from the studio": post the subscription alongside the message. keepalive lets it
    // finish while the page navigates, so the contact form submits untouched (and Shopify's bot check still runs).
    onSubmit = () => {
      const optin = this.querySelector('[data-contact-optin]');
      const email = this.querySelector('[data-contact-email]').value.trim();
      if (!optin.checked || !email || this.subscribed) return;
      this.subscribed = true;
      const body = new URLSearchParams({
        form_type: 'customer',
        utf8: '✓',
        'contact[email]': email,
        'contact[tags]': 'newsletter',
      });
      fetch('/contact', { method: 'POST', body, keepalive: true }).catch(() => {});
    };
  }
  if (!customElements.get('contact-page')) customElements.define('contact-page', ContactPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ArtworkGallery extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.gallery__slide:not(.gallery__slide--empty)')];
      this.track = this.querySelector('.gallery__track');
      this.dialog = this.querySelector('.lightbox');
      this.index = 0;
      this.addEventListener('click', this.onClick);
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.step(-1);
        if (event.key === 'ArrowRight') this.step(1);
      });
      this.track.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            if (!this.swipes()) return;
            const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
            if (index !== this.index) this.select(index);
          });
        },
        { passive: true }
      );
    }

    onClick = (event) => {
      const target = event.target;
      const thumb = target.closest('[data-thumb]');
      const dot = target.closest('[data-dot]');
      if (thumb) this.select(Number(thumb.dataset.thumb));
      else if (dot) this.select(Number(dot.dataset.dot), true);
      else if (target.closest('[data-lightbox]')) this.openLightbox();
      else if (target.closest('[data-lightbox-prev]')) this.step(-1);
      else if (target.closest('[data-lightbox-next]')) this.step(1);
      else if (target.closest('[data-lightbox-close]') || target === this.dialog) this.dialog.close();
    };

    // The mobile track scrolls; on desktop only the active slide shows
    swipes() {
      return this.track.scrollWidth > this.track.clientWidth + 1;
    }

    select(index, scroll = false) {
      const count = this.slides.length;
      if (!count) return;
      this.index = (index + count) % count;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
      this.querySelectorAll('[data-thumb]').forEach((el, i) => el.setAttribute('aria-pressed', i === this.index));
      this.querySelectorAll('[data-dot]').forEach((el, i) => {
        if (i === this.index) el.setAttribute('aria-current', 'true');
        else el.removeAttribute('aria-current');
      });
      const counter = this.querySelector('[data-count]');
      if (counter) counter.textContent = `${this.index + 1} / ${count}`;
      const caption = this.querySelector('[data-caption]');
      const alt = this.slides[this.index].dataset.alt;
      if (caption) caption.textContent = alt === this.dataset.title ? '' : alt;
      if (scroll && this.swipes()) {
        const smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      }
    }

    openLightbox() {
      if (!this.slides.length) return;
      this.fillLightbox();
      this.dialog.showModal();
    }

    step(delta) {
      this.select(this.index + delta, true);
      if (this.dialog.open) this.fillLightbox();
    }

    fillLightbox() {
      const slide = this.slides[this.index];
      const img = this.dialog.querySelector('[data-lightbox-img]');
      img.src = slide.dataset.full;
      img.alt = slide.dataset.alt;
      img.width = slide.dataset.width;
      img.height = slide.dataset.height;
      const count = this.slides.length;
      const caption = count > 1 ? `${this.index + 1} / ${count} · ${slide.dataset.alt}` : slide.dataset.alt;
      this.dialog.querySelector('[data-lightbox-caption]').textContent = caption;
    }
  }
  if (!customElements.get('artwork-gallery')) customElements.define('artwork-gallery', ArtworkGallery);

  class ArtworkPage extends HTMLElement {
    connectedCallback() {
      const gallery = this.querySelector('artwork-gallery');
      if (gallery) gallery.dataset.title = this.querySelector('.artwork__title')?.textContent.trim();

      this.addEventListener('change', (event) => {
        if (event.target.matches('.print-chip input')) this.choosePrint(event.target);
      });

      const cta = this.querySelector('[data-main-cta]');
      const bar = this.querySelector('[data-sticky-bar]');
      if (cta && bar) {
        // The root reaches far below the viewport, so "not intersecting" means "scrolled up past the top",
        // even after a jump (anchor link, restored scroll) that skips over the viewport entirely
        this.observer = new IntersectionObserver(
          ([entry]) => {
            const show = !entry.isIntersecting;
            bar.classList.toggle('is-visible', show);
            bar.inert = !show;
          },
          { rootMargin: '0px 0px 100000px 0px' }
        );
        this.observer.observe(cta);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    // Print size chips (§5.3): price, sticky bar and ?variant= follow the selection
    choosePrint(input) {
      this.querySelectorAll('[data-print-price]').forEach((el) => (el.textContent = input.dataset.price));
      this.querySelectorAll('[data-sticky-label]').forEach((el) => (el.textContent = input.dataset.sticky));
      this.querySelectorAll('[data-sticky-variant]').forEach((el) => (el.value = input.value));
      const url = new URL(location.href);
      url.searchParams.set('variant', input.value);
      history.replaceState(history.state, '', url);
    }
  }
  if (!customElements.get('artwork-page')) customElements.define('artwork-page', ArtworkPage);

  } catch(e) { console.error(e); }
})();
})();
